import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

const CardPartner = ({ name }) => (
  <div className='card-partner'>
    <p className='pt-half color-ui-1 txt-body-sm txt-font-body txt-left txt-bold'>
      { name ? <strong>{name}</strong> : <strong>&nbsp;</strong>}
    </p>
  </div>
)

CardPartner.propTypes = {
  name: PropTypes.string.isRequired
}

export default connect(
  ({ vendors }, { vendorId }) => vendors[vendorId]
)(CardPartner)



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductCard/CardPartner/index.js